import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import Card from '../../Card/Card'
import { getOrderbyType } from '../../../redux/actions/order-actions'
import { columnFilters, createSortString, getFormattedDate } from '../../../helper/helperFunctions'
import { Link } from 'react-router-dom'
import { adminConstants } from '../../../redux/constant/admin-constant'
import Pagination from '../../ThemeComponents/Pagination'

class MultipleShippedOrders extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filtered: ''
        }
    }

    inputChangeHandler = (e) => {
        this.setState({
            [e.target.name]: [e.target.value]
        })
    }

    paginationCall = (data) => {
        let matchFilterWith;
        if (this.pagination) {
            if (this.pagination.reactTable) {
                matchFilterWith = columnFilters(this.pagination.reactTable.state.columns[0].columns)
            }
        }
        let sorted = data.sort.split(',');
        let { sort, orderType } = createSortString(sorted);
        return this.props.getMultipleShipmentOrders('multiple_attempts_for_shipping', adminConstants.GET_MULTIPLE_SHIPMENT_ORDERS_SUCCESS, data.pageSize, sort, orderType, data.filter, matchFilterWith);
    }

    render() {
        const columns = [
            {
                Header: 'Program Types',
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: 'Barcode',
                        accessor: 'barcode',
                        width: 200,
                        className: 'action-center',
                        Cell: ({ value, original }) => {
                            return <Link to={`/Admin/${original.id}/order-edit`} className='blue_link'>{value}</Link>
                        }
                    },
                    {
                        Header: 'Departure Date',
                        accessor: 'order_dates.departure_date.value',
                        className: 'action-center',
                        id: 'orderDates.departure_date.value',
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        }
                    },
                    {
                        Header: 'Group Name',
                        accessor: 'group_name',
                        className: 'action-center'
                    },
                    {
                        Header: 'Contact Name',
                        accessor: 'group_leader_contact.first_name',
                        className: 'action-center',
                        id: 'groupLeaderContact.first_name'
                    },
                    {
                        Header: 'Contact Email',
                        accessor: 'group_leader_contact.email',
                        className: 'action-center',
                        id: 'groupLeaderContact.email'
                    },
                    {
                        Header: 'Contact Phone',
                        accessor: 'group_leader_contact.phone1',
                        className: 'action-center',
                        id: 'groupLeaderContact.phone1'
                    },
                    {
                        Header: 'Date Added to Unable To Contact List',
                        accessor: 'order_settings.multiple_attempts_for_shipping.updated_at',
                        className: 'action-center',
                        id: 'settings.multiple_attempts_for_shipping.updated_at',
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        }
                    },
                    {
                        Header: 'Contact Log',
                        className: 'action-center',
                        Cell: ({ original }) => {
                            return <Link to={{ pathname: `/Admin/${original.id}/order-edit`, state: { contactLog: true } }} className='blue_link'>Contact Log</Link>
                        },
                        sortable: false
                    },
                ]
            }
        ]
        return (
            <div className='content'>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card content={
                                <React.Fragment>
                                    <div className="secHeading">Multiple Shipment Attempted Orders</div>
                                    <div className='flexElem' style={{ justifyContent: 'space-between' }}>
                                        <div className='my-20 col-md-4'>
                                            {/* <input onChange={this.inputChangeHandler} type='text' name='filtered' className='form-control' placeholder='Search...' /> */}
                                        </div>
                                    </div>
                                    {/* <ReactTable
                                        noDataText='No Orders Found'
                                        manual
                                        columns={columns}
                                        data={this.props.multiple_shipment_orders.data}
                                        onFetchData={(state) => {
                                            let matchFilterWith = [];
                                            state.columns[0].columns.forEach(column => {
                                                if (column.id !== undefined || column.accessor !== undefined) {
                                                    if (column.id) {
                                                        matchFilterWith.push(column.id)
                                                    } else {
                                                        matchFilterWith.push(column.accessor)
                                                    }
                                                }
                                            })
                                            let sort = "", orderType = 'asc', filter = state.filtered;
                                            if (state.sorted.length > 0) {
                                                sort = state.sorted[0].id;
                                                orderType = state.sorted[0].desc;
                                                if (orderType === true) {
                                                    orderType = 'desc'
                                                } else {
                                                    orderType = 'asc'
                                                }
                                            }
                                            this.props.getMultipleShipmentOrders('multiple_attempts_for_shipping', adminConstants.GET_MULTIPLE_SHIPMENT_ORDERS_SUCCESS, state.pageSize, sort, orderType, filter, matchFilterWith);
                                        }}
                                    /> */}
                                    <div className='row'>
                                        <Pagination
                                            ref={(p) => this.pagination = p}
                                            showPagination={false}
                                            columns={columns}
                                            pageSize={10}
                                            getDataCall={this.paginationCall}
                                            filterView={true}
                                            noDataText='No Orders Found'
                                            // downloadData={true}
                                            // downloadFileName={'Orders'}
                                            // lowerContent = {null}
                                            filterPlaceHolder={'Orders'}
                                            getRowProps={this.getRowProps}
                                        // showAllToggle={true}
                                        />
                                    </div>
                                </React.Fragment>
                            } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { multiple_shipment_orders } = state.ordersReducer;
    return {
        multiple_shipment_orders
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMultipleShipmentOrders: (type, constant, pageSize, sort, orderType, filter, matchFilterWith) => { return dispatch(getOrderbyType(type, constant, pageSize, sort, orderType, filter, matchFilterWith)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleShippedOrders)
